export const alinaMatlakiewicz = {
    'meta': {
        'title': 'Psycholog, psychoterapeuta Alina Matlakiewicz',
        'description': 'Jestem wykładowcą, psychoterapeutą poznawczo-behawioralnym, pedagogiem, psychologiem biznesu i certyfikowanym coachem.'
    },
    'url': {
        'address': '/torun/zespol/psycholog-biznesu-psychoterapeuta-alina-matlakiewicz/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/alina-matlakiewicz.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog w Toruniu, Psychoterapeuta w Toruniu Alina Matlakiewicz'
        }
    }
}